class INTENT.widgets.Folding

  @ATTR_NAME: "data-widget-folding"

  @ATTR_HANDLER: "#{@ATTR_NAME}-handler"
  @ATTR_CONTAINER: "#{@ATTR_NAME}-container"

  @ICON_OPEN: "glyphicon glyphicon-chevron-right"
  @ICON_CLOSE: "glyphicon glyphicon-chevron-down"

  @OPACITY_CLASS: "opacity-dynamic"

  @SLIDER_SPEED: 500

  constructor: (@el) ->
    @s = @.constructor

    @handler = @el.find "[#{@s.ATTR_HANDLER}]"
    @container = @el.find "[#{@s.ATTR_CONTAINER}]"
    @opacity = @el.attr(@s.ATTR_NAME) == 'opacity'

    unless @container.is(':visible')
      @handler.addClass @s.OPACITY_CLASS

    @handler.on 'click', =>
      @update_icon()

      if @container.is ':visible'
        if @opacity
          @handler.addClass @s.OPACITY_CLASS

        @container.slideUp @s.SLIDER_SPEED
      else
        if @opacity
          @handler.removeClass @s.OPACITY_CLASS

        @container.slideDown @s.SLIDER_SPEED

  update_icon: =>
    icon = @handler.find "i"
    iconOpen = "glyphicon glyphicon-chevron-down"
    if icon.attr('attr-open') != '' && icon.attr('attr-open') != undefined && icon.attr('attr-open') != null
      iconOpen = "glyphicon glyphicon-chevron-"+icon.attr('attr-open')
    iconClose = "glyphicon glyphicon-chevron-right"
    if icon.attr('attr-close') != '' && icon.attr('attr-close') != undefined && icon.attr('attr-close') != null
      iconClose = "glyphicon glyphicon-chevron-"+icon.attr('attr-close')
    if @container.is ':visible'
      icon.attr 'class', iconClose
    else
      icon.attr 'class', iconOpen
